import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Block } from 'src/app/phonenumber/phonenumber.model';

@Component({
  selector: 'app-endcustomer-cancel-phonenumber-order-complete',
  templateUrl: './endcustomer-cancel-phonenumber-order-complete.component.html',
  standalone: false
})
export class EndcustomerCancelPhonenumberOrderCompleteComponent {
  @Input() block: Block;
  @Output() next = new EventEmitter();
}
